import React from 'react'
import Image from '../../../images/sellerpolicies/22.png'

const Taxes = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Taxes</h2>
            <p>The Seller shall be responsible for payment of all customs duties, sales tax, excise tax, value-added tax, and any other duties, excess, fees, or charges of whatsoever nature which may be imposed by governing authorities of any jurisdiction applicable in connection with sale or supply of its Products on the Platform and their purchase by Customers. It is clarified that the Seller shall be solely responsible for the payment of any sales tax on the supply of these Products to the Customer through the Platform and KAAY shall have no liability in this regard.</p>
        </div>
      </div>
    </div>
  )
}

export default Taxes
